<i class="fas fa-check" [hidden]="!status" style="color: green"></i>
<i class="fas fa-times" [hidden]="status" style="color: red"></i>
